import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialLinks from './SocialLinks';

export const SiteFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-inner">
          <SocialLinks />
          <p className="footer-text">&copy; 2026 BuckTime! All Rights Reserved.</p>
          <nav className="footer-links" data-testid="footer-nav">
            <a
              href="/privacy"
              className="footer-link"
              onClick={(e) => { e.preventDefault(); navigate('/privacy'); }}
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </a>
            <span className="footer-divider">|</span>
            <a
              href="/terms"
              className="footer-link"
              onClick={(e) => { e.preventDefault(); navigate('/terms'); }}
              data-testid="footer-terms-link"
            >
              Terms of Service
            </a>
            <span className="footer-divider">|</span>
            <a
              href="mailto:support@bucktime.ca"
              className="footer-link"
              data-testid="footer-support-link"
            >
              Support
            </a>
          </nav>
          <p className="footer-location" data-testid="footer-location">Built in Ontario, Canada</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
